<template>
	<div class="dashboard-customizado">
		<!-- Barra com o seletor: exibida apenas quando o cliente tem mais de um dashboard -->
		<div
			v-if="possuiMaisDeUm"
			class="dashboard-customizado__barra"
		>
			<label
				class="dashboard-customizado__label"
				for="dashboard-customizado-select"
			>
				{{ $t('selectReport') }}:
			</label>
			<select
				id="dashboard-customizado-select"
				class="dashboard-customizado__select"
				:value="nomeRelatorio"
				@change="selecionarRelatorio($event.target.value)"
			>
				<option
					v-for="dashboard in dashboards"
					:key="dashboard.name"
					:value="dashboard.name"
				>
					{{ dashboard.title || dashboard.name }}
				</option>
			</select>
			<button
				type="button"
				class="dashboard-customizado__acao"
				:disabled="loading"
				:title="$t('recarregarRelatorio')"
				@click="carregarRelatorio()"
			>
				<i class="fas fa-sync-alt" />
			</button>
		</div>

		<div class="dashboard-customizado__conteudo">
			<div
				v-if="loading"
				class="dashboard-customizado__estado"
			>
				<v-progress-circular
					indeterminate
					color="primary"
					size="40"
				/>
			</div>
			<div
				v-else-if="semRelatorio"
				class="dashboard-customizado__estado"
			>
				<i class="fas fa-file-alt dashboard-customizado__estado-icone" />
				<p>{{ $t('semRelatorioCadastrado') }}</p>
			</div>
			<div
				v-else-if="erro"
				class="dashboard-customizado__estado"
			>
				<p>{{ $t('erroAoCarregarDashboard') }}</p>
				<button
					type="button"
					class="dashboard-customizado__acao"
					@click="carregarRelatorio()"
				>
					{{ $t('tentarNovamente') }}
				</button>
			</div>
			<iframe
				v-else
				class="dashboard-customizado__frame"
				:src="url"
				:title="tituloSelecionado"
			/>
		</div>
	</div>
</template>

<script>
import {
	getRelatorioCustomizado,
	getDashboardsCustomizados,
} from '../../services/requests/DashBoardRequests'

export default {
	data() {
		return {
			// Dashboards do cliente logado (o backend resolve por customer_id via /list).
			dashboards: [],
			url: '',
			loading: true,
			erro: false,
			// Cliente sem nenhum dashboard, ou dashboard inexistente no backend.
			semRelatorio: false,
		}
	},
	computed: {
		// Relatorio exibido: vem da rota; se a rota nao trouxer, usa o primeiro do cliente.
		nomeRelatorio() {
			return this.$route.params.nome || (this.dashboards[0] && this.dashboards[0].name) || ''
		},
		possuiMaisDeUm() {
			return this.dashboards.length > 1
		},
		tituloSelecionado() {
			const dashboard = this.dashboards.find((d) => d.name === this.nomeRelatorio)
			return (dashboard && dashboard.title) || 'Dashboard Customizado'
		},
	},
	watch: {
		// Recarrega ao trocar de relatorio (via seletor) sem sair da rota.
		nomeRelatorio(novo, antigo) {
			if (novo && novo !== antigo) this.carregarRelatorio()
		},
	},
	async created() {
		await this.carregarLista()
		this.carregarRelatorio()
	},
	methods: {
		async carregarLista() {
			try {
				const resposta = await getDashboardsCustomizados()
				this.dashboards = (resposta && resposta.data ? resposta.data : []).filter((d) => d.isActive)
			} catch {
				this.dashboards = []
			}
		},
		// Troca o relatorio mantendo a URL sincronizada (link compartilhavel).
		selecionarRelatorio(nome) {
			if (!nome || nome === this.nomeRelatorio) return
			this.$router.replace({ name: 'dashboardCustomizado', params: { nome } })
		},
		carregarRelatorio() {
			const nome = this.nomeRelatorio

			// Cliente sem nenhum dashboard liberado: nem chega a requisitar.
			if (!nome) {
				this.url = ''
				this.erro = false
				this.semRelatorio = true
				this.loading = false
				return
			}

			this.loading = true
			this.erro = false
			this.semRelatorio = false
			getRelatorioCustomizado(nome)
				.then((response) => {
					// Ignora resposta de um relatorio que nao esta mais selecionado.
					if (nome !== this.nomeRelatorio) return
					this.url = response && response.data ? response.data.url : ''
					if (!this.url) this.erro = true
				})
				.catch((error) => {
					if (nome !== this.nomeRelatorio) return
					// 404 = o cliente nao possui esse dashboard (nao e falha de carregamento).
					if (error && error.response && error.response.status === 404) {
						this.semRelatorio = true
					} else {
						this.erro = true
					}
				})
				.finally(() => {
					if (nome === this.nomeRelatorio) this.loading = false
				})
		},
	},
}
</script>

<style scoped>
.dashboard-customizado {
	/* Ocupa a area de conteudo entre o header (4rem) e o footer (2.5rem) do Main.vue */
	height: calc(100vh - 4rem - 2.5rem);
	width: 100%;
	display: flex;
	flex-direction: column;
}

.dashboard-customizado__barra {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.5rem 1rem;
	border-bottom: 1px solid #e0e0e0;
	flex: 0 0 auto;
}

.dashboard-customizado__label {
	font-weight: 600;
}

.dashboard-customizado__select {
	padding: 0.35rem 0.5rem;
	border: 1px solid #c0c0c0;
	border-radius: 4px;
	min-width: 220px;
}

.dashboard-customizado__acao {
	cursor: pointer;
	border: 1px solid #c0c0c0;
	background: #fff;
	border-radius: 4px;
	padding: 0.35rem 0.6rem;
}

.dashboard-customizado__acao:disabled {
	opacity: 0.5;
	cursor: default;
}

.dashboard-customizado__conteudo {
	flex: 1 1 auto;
	position: relative;
}

.dashboard-customizado__frame {
	width: 100%;
	height: 100%;
	border: 0;
}

.dashboard-customizado__estado {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	align-items: center;
	justify-content: center;
	height: 100%;
}

.dashboard-customizado__estado-icone {
	font-size: 2rem;
	color: #9e9e9e;
}
</style>
